import React, { useState } from 'react';
import { cn } from '@client/lib/utils';
import { NavigationBar } from '@client/components/layout';
import { createTask } from '@client/lib/api';

export function AddTaskPage() {
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (description.length < 10) {
      setError('Die Fotoidee muss mindestens 10 Zeichen haben');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await createTask(description);
      setSuccess(true);
      setDescription('');
      
      // Reset success message after 3 seconds
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Fehler beim Erstellen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[var(--color-ios-grouped-background)]">
      <NavigationBar title="Fotoidee" />

      <div className="p-4">
        <div className="bg-card rounded-2xl p-6">
          <div className="text-center mb-6">
            <div className="text-5xl mb-3">✨</div>
            <h2 className="text-[22px] leading-[28px] font-bold mb-2">
              Fotoidee einreichen
            </h2>
            <p className="text-[15px] leading-[20px] text-muted-foreground">
              Denk dir eine Mission für andere aus, die uns später zum Lachen bringt.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="z.B. Macht ein Foto mit jemandem, den ihr heute erst kennengelernt habt"
                className={cn(
                  'w-full h-32 px-4 py-3 bg-secondary rounded-xl',
                  'text-[17px] leading-[22px]',
                  'placeholder:text-muted-foreground resize-none',
                  'focus:outline-none focus:ring-2 focus:ring-primary'
                )}
                maxLength={200}
                disabled={loading}
              />
              <p className="text-[12px] leading-[16px] text-muted-foreground text-right mt-1">
                {description.length}/200
              </p>
            </div>

            {error && (
              <p className="text-destructive text-[13px] leading-[18px] text-center">
                {error}
              </p>
            )}

            {success && (
              <p className="text-[#34C759] text-[13px] leading-[18px] text-center">
                Fotoidee hinzugefügt!
              </p>
            )}

            <button
              type="submit"
              disabled={loading || description.length < 10}
              className={cn(
                'w-full py-3.5 bg-primary text-primary-foreground rounded-[14px]',
                'text-[17px] leading-[22px] font-semibold',
                'disabled:opacity-50 ios-pressable'
              )}
            >
              {loading ? 'Moment...' : 'Idee hinzufügen'}
            </button>
          </form>
        </div>

        <p className="text-[13px] leading-[18px] text-center text-muted-foreground mt-4 px-4">
          Deine Idee wird zufällig als Foto-Mission an andere Gäste verteilt.
        </p>
      </div>
    </div>
  );
}
